import { useQuery } from '@tanstack/react-query';
import type { RankingQuery } from '@troia-v3/types';

import { rankingApi } from '../services/rankingApi';

export const RANKING_KEYS = {
  ranking: (query: RankingQuery) => ['gamification', 'ranking', query] as const,
  me: ['gamification', 'me'] as const,
};

/** Ranking (`GET /api/gamification/ranking`) — cache de 60s, igual ao do backend. */
export const useRanking = (query: RankingQuery, enabled = true) =>
  useQuery({
    queryKey: RANKING_KEYS.ranking(query),
    queryFn: () => rankingApi.getRanking(query),
    staleTime: 60_000,
    enabled,
    placeholderData: (prev) => prev,
  });

/** Meus números (`GET /api/gamification/me`). */
export const useGamificationMe = (enabled = true) =>
  useQuery({ queryKey: RANKING_KEYS.me, queryFn: () => rankingApi.getMe(), staleTime: 60_000, enabled });
